import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'components/form/Button'
import Table from 'components/table/Table'
import Icon from 'components/Icon'
import {
  deleteImageList,
  fetchImageList,
  reset,
  setImageSize,
  setPage,
  setSize,
} from 'features/image/imageListSlice'
import {
  hideImageLibraryModal,
  showImageUploadModal,
} from 'features/image/imageLibrarySlice'
import ImageLibraryModal from 'features/image/ImageLibraryModal'
import PageHeader from '../../components/PageHeader'
import { downloadCsvFile } from 'utils'
import { fail, success } from 'features/toast/Toast'
import { useConfirm } from 'features/dialog/Confirm'
import Pagination from 'components/pagination/Pagination'
import PageSize from 'components/pagination/PageSize'
import api from 'api/axios/foka'
import moment from 'moment'
import NoneAnchor from 'components/NoneAnchor'

const ImageList = () => {
  const dispatch = useDispatch()
  const { isLoading, imageSize, totalElements, content, page, size } =
    useSelector(state => state.image.imageList)
  const [selectedIds, setSelectedIds] = useState([])
  const [DeleteConfirm, showDeleteConfirm] = useConfirm()

  useEffect(() => {
    dispatch(fetchImageList())
  }, [dispatch, imageSize, page, size])

  useEffect(
    () => () => {
      setSelectedIds([])
      dispatch(reset())
      dispatch(hideImageLibraryModal())
    },
    [dispatch]
  )

  // eslint-disable-next-line no-unused-vars
  const handleImageSizeChange = value => {
    dispatch(setImageSize(value))
  }

  const showModal = () => {
    dispatch(showImageUploadModal())
  }

  const handleDelete = async ({ isConfirmed }) => {
    if (isConfirmed) {
      const { error, payload } = await dispatch(deleteImageList(selectedIds))
      if (error) {
        fail(payload.errorMessage)
      } else {
        success('이미지가 삭제되었습니다.')
        dispatch(fetchImageList())
      }
    }
  }

  const handleDownload = async () => {
    try {
      const response = await api.image.downloadDspImages({
        width: imageSize ? imageSize.width : '',
        height: imageSize ? imageSize.height : '',
      })
      downloadCsvFile(
        response.data,
        `image_lib_${moment().format(moment.HTML5_FMT.DATE)}${
          imageSize ? `_${imageSize.width}x${imageSize.height}` : ''
        }.csv`
      )
    } catch (e) {
      fail('알 수 없는 에러가 발생했습니다.')
    }
  }

  const handlePageChange = v => dispatch(setPage(v))
  const handleSizeChange = v => dispatch(setSize(v))

  return (
    <>
      <div className="imgmanage_wrap">
        <div className="dsp_tit">
          <PageHeader pageTitle="이미지 관리" />
        </div>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">
              총 이미지 <em className="fc_emph">{totalElements}</em>
            </strong>
            <div className="f_left">
              <div className="single_wrap">
                <Button primary onClick={showModal}>
                  <span className="img_comm ico_add" />
                  이미지 등록하기
                </Button>
              </div>
              <div className="single_wrap">
                <Button
                  line
                  onClick={showDeleteConfirm}
                  disabled={selectedIds.length === 0}>
                  삭제
                </Button>
              </div>
            </div>
            <div className="f_right">
              {/* KEYWORDAD-285 */}
              {/* <div className="single_wrap">
              <SelectBox noBlurOnDefault value={imageSize} onValueChange={handleImageSizeChange}>
                <SelectBox.Item value={null}>전체</SelectBox.Item>
                <SelectBox.Item value={ImageSizes['300x300']}>300x300</SelectBox.Item>
                <SelectBox.Item value={ImageSizes['450x450']}>450x450</SelectBox.Item>
                <SelectBox.Item value={ImageSizes['640x480']}>640x480</SelectBox.Item>
                <SelectBox.Item value={ImageSizes['1200x628']}>1200x628</SelectBox.Item>
              </SelectBox>
            </div> */}
              <div className="single_wrap">
                <Button
                  line
                  icon
                  onClick={handleDownload}
                  disabled={totalElements === 0}>
                  <Icon name="download">다운로드</Icon>
                </Button>
              </div>
            </div>
          </div>
          <div className="tblg2_wrap">
            <Table
              className="tbl_g2"
              caption="이미 관리 표"
              selectedIds={selectedIds}
              onSelectionChange={ids => setSelectedIds(ids)}
              loading={isLoading}
              emptyMessage={
                <>
                  등록된 이미지 목록이 없습니다.
                  <br />
                  <NoneAnchor className="link_txt" onClick={showModal}>
                    이미지 등록하기
                  </NoneAnchor>
                  를 클릭하여 새로운 이미지를 등록하세요.
                </>
              }>
              <Table.Head>
                <Table.Column
                  checkbox
                  width={57}
                  className="th_select align_c"
                />
                <Table.Column title="등록일시" width={180} />
                <Table.Column title="이미지ID" width={180} />
                <Table.Column title="미리보기" width={168} />
                <Table.Column title="이미지 사이즈" width={168} />
                <Table.Column title="이미지 파일명" />
              </Table.Head>
              <Table.Body>
                {content.map(
                  ({ id, url, name, width, height, createdDate }) => (
                    <Table.Row key={id} rowId={id}>
                      <td>
                        <div className="inner_tbl">{createdDate}</div>
                      </td>
                      <td>
                        <div className="inner_tbl">{id}</div>
                      </td>
                      <td>
                        <div className="inner_tbl">
                          <div className="box_thumb">
                            <NoneAnchor className="link_thumb">
                              <span
                                className="inner_thumb"
                                style={{ backgroundImage: `url(${url})` }}
                              />
                            </NoneAnchor>
                            <div className="preview_thumb">
                              <strong className="tit_preview">미리보기</strong>
                              <div className="detail_thumb">
                                <img
                                  src={url}
                                  alt="소재이미지"
                                  className="img_thumb"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="inner_tbl">
                          {width} x {height}
                        </div>
                      </td>
                      <td>
                        <div className="inner_tbl">{name}</div>
                      </td>
                    </Table.Row>
                  )
                )}
              </Table.Body>
            </Table>
          </div>
          {totalElements > 0 && (
            <div className="paging_wrap">
              <div className="inner_paging">
                <Pagination
                  total={totalElements}
                  current={page}
                  size={size}
                  onChange={handlePageChange}
                />
                <PageSize
                  onSizeChange={s => {
                    handlePageChange(0)
                    handleSizeChange(s)
                  }}
                  size={size}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <DeleteConfirm title="이미지 삭제" onClose={handleDelete}>
        이미지를 삭제하시겠습니까?
      </DeleteConfirm>
      <ImageLibraryModal
        afterConfirm={() => {
          dispatch(fetchImageList())
        }}
      />
    </>
  )
}

export default ImageList
